import * as React from "react";

import "./analytics-lead-info.scss";
import {InternalLink}               from "@Xpresso/routes/common/components/internal-link";
import {faClose}                    from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}            from "@fortawesome/react-fontawesome";
import {formatDate1}                from "@Common/ui-components/format-date";
import {titleCase}                  from "../analytics-leads/analytics-lead-card/analytics-lead-card";
import {xdQAAttribute}              from "../analytics-layout";

const URL_PATH_ANALYTICS = '/analytics'
const URL_PATH_ORDER_HISTORY = '/account/orders/history'

export const AnalyticsLeadInfo = ({leadInfo, setLeadInfo}) => {
    const [tabSelected, setTabSelected] = React.useState(0)

    const leadName = titleCase(leadInfo?.name)

    return (
        <div
            className={`lead-info-overlay-dznts2 ${leadInfo ? "" : " collapsed"}`}
            onClick={() => {
                if(leadInfo) {
                    setLeadInfo(null)
                }
            }}
        >
            <div
                className="modal"
                onClick={(e) => {
                    e.stopPropagation()
                }}
                {...xdQAAttribute('modal', 'lead info modal')}
            >
                <div className="header">
                    <FontAwesomeIcon
                        className="icon"
                        icon={faClose}
                        onClick={() => {
                            if(leadInfo) {
                                setLeadInfo(null)
                            }
                        }}
                        {...xdQAAttribute('icon', 'close lead info')}
                    />
                    <span
                        className="lead-name"
                        {...xdQAAttribute('text', `lead name ${leadName}`)}
                    >
                        {leadName}
                    </span>
                </div>
                <div className="tabs">
                    {
                        tabs.map((tab, i) => {
                            return (
                                <div
                                    key={tab.label}
                                    className={`${tabSelected === i ? 'selected ': ''}tab`}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        setTabSelected(i)
                                    }}
                                    style={{
                                        width: `${(100 / tabs.length).toFixed(0)}%`
                                    }}
                                    {...xdQAAttribute('tab', tab.label)}
                                >
                                    {tab.label}
                                </div>
                            )
                        })
                    }
                </div>
                {
                    content(tabSelected, leadInfo)
                }
            </div>
        </div>
    )

}

const tabs = [
    {
        label: 'Interactions',
        type: 'interactions'
    },
    {
        label: 'Lead Info',
        type: 'leadInfo'
    }
]

const content = (tabSelected, leadInfo) => {
    const tab = tabs[tabSelected].type
    switch(tab) {
        case 'leadInfo':
            return (
                LeadInfo(leadInfo)
            )
        case 'interactions':
        default:
            return (
                Interactions(leadInfo)
            )

    }
}

const LeadInfo = (leadInfo) => {
    if(!leadInfo) {
        return
    }

    const fields = [
        {
            key: 'address',
            label: 'Address'
        },
        {
            key: 'phone',
            label: 'Phone Number'
        },
        {
            key: 'email',
            label: 'Email'
        }
    ]

    return (
        <div className="lead-info">
            {
                fields.map(field => {
                    if(!leadInfo[field.key]) {
                        return
                    }
                    const fieldValue = leadInfo[field.key]
                    let contactMethod = addressFormatted(leadInfo)
                    switch(field.key) {
                        case 'phone':
                            contactMethod = (
                                <a
                                    className="link"
                                    href={`tel://${fieldValue}`}
                                    {...xdQAAttribute('link', 'lead phone')}
                                >
                                    {fieldValue}
                                </a>
                            )
                            break
                        case 'email':
                            contactMethod = (
                                <a
                                    className="link"
                                    href={`mailto:${fieldValue}`}
                                    target="_blank"
                                    {...xdQAAttribute('link', 'lead email')}
                                >
                                    {fieldValue}
                                </a>
                            )
                            break
                        case 'address':
                        default:
                            break
                    }
                    return (
                        <React.Fragment key={field.key}>
                            <div className="info">
                                <div className="label">
                                    {field.label}
                                </div>
                                <div className="value">
                                    {contactMethod}
                                </div>
                            </div>
                            <hr />
                        </React.Fragment>
                    )
                })
            }
        </div>
    )
}

const Interactions = (leadInfo) => {
    if(!leadInfo) {
        return
    }

    if(!leadInfo.interactions) {
        return
    }

    return (
        <div className="interactions">
            {
                leadInfo.interactions.map((interaction, index) => {
                    return (
                        <React.Fragment key={index} >
                            {Interaction(interaction, index)}
                            <hr />
                        </React.Fragment>
                    )
                })
            }
        </div>
    )
}

const Interaction = (interaction, index) => {
    const message = interaction.type === 'formSubmission' ? parseMessage(interaction) : ''
    const orderName = interaction.orderName ?? ''
    const redirectUrl = urlFormatted(interaction.redirectUrl) ?? ''
    const orderParam = ''
    const agentAccepted = parseInt(interaction.agentAccepted) > 0
    const queryOrderId = interaction.idOrder ? `?orderId=${interaction.idOrder}` : ''

    return (
        <div
            className="interaction"
            {...xdQAAttribute('card', index + 1)}
        >
            <div className={`date${agentAccepted ? '' : ' pip'}`}>
                {dateTimeFormatted(interaction.dateCreated.date)}
            </div>
            <div
                className="type"
                {...xdQAAttribute('text', interaction.type)}
            >
                {interactionTypeText(interaction.type)}
            </div>
            {
                message &&
                <div className="message">
                    <div
                        className="message-header"
                        {...xdQAAttribute('text', 'message header')}
                    >
                        Message
                    </div>
                    <div
                        className="message-body"
                        {...xdQAAttribute('text', 'message body')}
                    >
                        {message}
                    </div>
                </div>
            }
            {
                orderName &&
                <div className="order">
                    <InternalLink
                        className="link"
                        to={`${URL_PATH_ORDER_HISTORY}${queryOrderId}`}
                        {...xdQAAttribute('link', 'order history')}
                    >
                        {orderName}
                    </InternalLink>
                </div>
            }
            {
                redirectUrl &&
                <div className="redirect">
                    <div className="redirect-header">
                        Redirected to
                    </div>
                    <a
                        className="link"
                        href={redirectUrl}
                        target='_blank'
                        {...xdQAAttribute('link', `redirected to`)}
                    >
                        {redirectUrl}
                    </a>
                </div>
            }
        </div>
    )
}

const urlFormatted = (url) => {
    if(!url) {
        return null
    }

    if(url.startsWith('https://')) {
        return url
    }

    if(url.startsWith('http://')) {
        return url
    }

    return `https://${url}`
}

const dateTimeFormatted = (dateTime) => {
    const timeZoneOffsetServer = '-05:00'
    const date = new Date(`${dateTime}${timeZoneOffsetServer}`)

    const formattedDate = date.toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    })

    return formattedDate.replace(',', '')
}

const interactionTypeText = (type) => {
    switch(type) {
        case 'qr':
            return 'Scanned QR on'
        case 'informedDelivery':
            return 'Clicked Informed Delivery Link'
        case 'homeValueForm':
            return 'Home Value Form'
        case 'formSubmission':
        default:
            return 'Contact Form'
    }
}

const parseMessage = (interaction) => {
    const json = JSON.parse(interaction.data)
    return json.description ?? ''
}

const addressFormatted = (leadInfo) => {
    if(!leadInfo.address) {
        return ''
    }
    if(!leadInfo.zip) {
        return ''
    }
    const city = leadInfo.city ? (titleCase(leadInfo.city) + ',') : ''

    return (
        <>
            <span
                className="address"
                {...xdQAAttribute('label', 'address1')}
            >
                {titleCase(leadInfo.address)}
            </span>
            {
                leadInfo.address2 &&
                <span
                    className="address2"
                    {...xdQAAttribute('label', 'address2')}
                >
                    {titleCase(leadInfo.address)}
                </span>
            }
            {
                <span
                    className="city"
                    {...xdQAAttribute('label', 'city')}
                >
                    {`${city} ${leadInfo.state} ${leadInfo.zip}`}
                </span>
            }
        </>
    )
}